import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '../ui/Button';
export function SystemTypesHero() {
  const scrollToComparison = () => {
    const element = document.getElementById('system-comparison');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-slate-900 py-20 md:py-32 overflow-hidden min-h-[70vh] flex items-center" data-id="element-1161">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-1162">
        <div className="absolute inset-0 bg-slate-900/70 z-10" data-id="element-1163"></div>
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://images.unsplash.com/photo-1483664852095-d6cc6870702d?q=80&w=2070&auto=format&fit=crop" data-id="element-1164">
          <source src="https://cdn.magicpatterns.com/uploads/gVfFpdrefsXLf2ttSaXFT7/2e5fd22b26ef49c6ad1f7e7527a79d9f.undefined" type="video/mp4" data-id="element-1165" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 -z-10" data-id="element-1166"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-20 text-center" data-id="element-1167">
        <div className="max-w-3xl mx-auto space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700" data-id="element-1168">
          <div className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary-foreground mb-4 backdrop-blur-sm" data-id="element-1169">
            <span className="flex h-2 w-2 rounded-full bg-primary mr-2" data-id="element-1170"></span>
            Honest Advice &bull; No Sales Pressure
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-lg" data-id="element-1171">
            Which Heated Driveway System Is Right for You?
          </h1>

          <p className="text-xl text-slate-200 leading-relaxed drop-shadow-md" data-id="element-1172">
            Forget the technical hype. Let's focus on what actually matters:
            reliability, operating costs, and simplicity.
          </p>

          <p className="text-base text-slate-300 max-w-2xl mx-auto drop-shadow-md" data-id="element-1173">
            We help you decide honestly—not push the most expensive option.
            Whether it's electric or hydronic, we'll tell you if it's a good fit
            (or if you should stick with a snow blower).
          </p>

          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1174">
            <Button size="lg" onClick={scrollToComparison} className="min-w-[200px] border border-white shadow-lg" data-id="element-1175">
              Compare Systems
            </Button>
            <Button variant="outline" size="lg" className="min-w-[200px] bg-white/5 border-white/20 text-white hover:bg-white/20 hover:text-white backdrop-blur-sm" onClick={() => {
            const element = document.getElementById('decision-guide');
            if (element) element.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-1176">
              Take the Quiz
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/50 z-20" data-id="element-1177">
        <ChevronDown className="h-8 w-8" data-id="element-1178" />
      </div>
    </section>;
}